<script>
  export let pageInfo;
</script>

<section class="other-page">
  <h3 class="other-page__title">{pageInfo.title}</h3>
  <p class="other-page__text">{pageInfo.text}</p>
  <div class="other-page__more">
    <a href={pageInfo.url} class="btn btn-main btn-icon">
      <i class="isax isax-arrow-right-3" />
      <span>{pageInfo.title}</span>
    </a>
  </div>
</section>

<style lang="scss">
  .other-page {
    padding: 10rem 5rem;
    border-top: 1px solid $light-border;
    text-align: center;

    &__title {
      //   text-align: center;
    }

    &__text {
      margin: 2rem auto 0;
      color: var(--royal-light);
      max-width: 70rem;
    }

    &__more {
      margin-top: 2rem;
    }
  }
</style>
